import { FunctionComponent, MouseEventHandler, ReactNode } from 'react';
import { BoxSelect } from 'dibs-elements/exports/BoxSelect';
import styles from '../../styles/ACHForm.scss';

type Option = {
    label: ReactNode;
    value: string;
};

type Props = {
    value: string;
    disabled?: boolean;
    onChange: MouseEventHandler<HTMLButtonElement>;
    options: Option[];
};

const AccountType: FunctionComponent<Props> = ({ value, disabled, onChange, options }) => (
    <div className={styles.boxSelectContainer}>
        <BoxSelect
            dataTn="billing-achAccountType"
            value={value}
            disabled={disabled}
            onChange={onChange}
            options={options}
        />
    </div>
);

export default AccountType;
